"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegerFormats = exports.WaylayTypes = exports.ContentType = void 0;
var ContentType;
(function (ContentType) {
    ContentType["JSON"] = "json";
    ContentType["YAML"] = "yaml";
    ContentType["UNKNOWN"] = "unknown";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var WaylayTypes;
(function (WaylayTypes) {
    WaylayTypes["STRING"] = "string";
    WaylayTypes["INTEGER"] = "integer";
    WaylayTypes["DOUBLE"] = "double";
    WaylayTypes["OBJECT"] = "object";
    WaylayTypes["BOOLEAN"] = "boolean";
    WaylayTypes["LONG"] = "long";
    WaylayTypes["FLOAT"] = "enum";
})(WaylayTypes = exports.WaylayTypes || (exports.WaylayTypes = {}));
var IntegerFormats;
(function (IntegerFormats) {
    IntegerFormats["INT32"] = "int32";
    IntegerFormats["INT64"] = "int64";
})(IntegerFormats = exports.IntegerFormats || (exports.IntegerFormats = {}));
